export default __webpack_public_path__ + "static/media/formalpic.0a504d0a.jpg";